import { render, staticRenderFns } from "./WarehouseLocations.vue?vue&type=template&id=2f3061cc&scoped=true"
import script from "./WarehouseLocations.vue?vue&type=script&lang=js"
export * from "./WarehouseLocations.vue?vue&type=script&lang=js"
import style0 from "./WarehouseLocations.vue?vue&type=style&index=0&id=2f3061cc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f3061cc",
  null
  
)

export default component.exports